module.exports = __webpack_public_path__ + "static/media/career-seek-logo.805ae6aa.png";